<template>
  <div class="x-background-image"></div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component
export default class XBackgroundImage extends Vue {}
</script>

<style scoped>
.x-background-image {
  background-image: url("~@/assets/images/layout/x-login-background.svg");
  width: 130vw;
  height: 130vh;
  display: flex;
  position: fixed;
  top: -50px;
  left: -500px;
  background-size: 100% 100%;
  opacity: 0.1;
}
</style>
